export const FailReasonOptions = [
  {
    key: 0,
    text: 'ALL',
    value: 0,
  },
  {
    key: 1,
    text: 'False Duplicates',
    value: 1,
  },
  {
    key: 2,
    text: 'Invalid Student Number',
    value: 2,
  },
  {
    key: 3,
    text: 'Invalid Serving Number',
    value: 3,
  },
  {
    key: 4,
    text: 'Duplicate Serving Number',
    value: 4,
  },
  {
    key: 5,
    text: 'Invalid Site',
    value: 5,
  },
  {
    key: 6,
    text: 'Invalid Enroll Flag',
    value: 6,
  },
  {
    key: 7,
    text: 'Duplicate Entry',
    value: 7,
  },
  {
    key: 8,
    text: 'Removed from Verification',
    value: 8,
  },
  {
    key: 9,
    text: 'Invalid Meal Status',
    value: 9,
  },
  {
    key: 10,
    text: 'Invalid Grade Id',
    value: 10,
  },
  {
    key: 11,
    text: 'Invalid Name',
    value: 11,
  },
];



// WEBPACK FOOTER //
// ./src/pages/importlog/constants/index.js